import React from 'react';

export default function StoreInfo({
    store = {},
    className=null
}){
    function displayStoreInfo(){
        if (Object.entries(store).length){
            return (<div className={className}>
                        {/* <img src={images.etyel_logo} alt="Icon"  className="brand-image mb-2" style={{maxWidth: '150px'}} /> */}
                        {/* <h5 className='mb-0'><b>{store.business_name}</b></h5> */}
                        <p className='mb-0'><b>{store.business_name}</b></p>
                        <address className='mb-0' style={{fontSize: '14px'}}>
                            {store.address}
                        </address>
                        <div style={{fontSize: '14px'}}>{store.email}</div>
                        <div style={{fontSize: '14px'}}>{store.phone_no}</div>
                    </div>)
        }
    }

    return displayStoreInfo()
}
